/**
 * Main Application Entry Point
 * Falcon Terminal
 */

import React from "react";

import ReactDOM from "react-dom/client";

import { App } from "./App";
import "../../shared/src/styles/globals.css";
import "./App.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Failed to find the root element");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
